import { Store } from "@/models/customersTypes";

export const comingSoonStores: Store[] = [
    {
        id: 101,
        name: "Alsbach-Hähnlein",
        street: "Gernsheimer Straße 42",
        city: "Alsbach-Hähnlein",
        zip: "64665",
        latitude: 49.7357,
        longitude: 8.5736,
    },
    {
        id: 102,
        name: "Bad Hersfeld",
        street: "Friedloser Straße 3",
        city: "Bad Hersfeld",
        zip: "36251",
        latitude: 50.8709,
        longitude: 9.7157,
    },
    {
        id: 103,
        name: "Darmstadt, Frankfurter Straße",
        street: "Frankfurter Straße 127",
        city: "Darmstadt",
        zip: "64293",
        latitude: 49.892,
        longitude: 8.6538,
    },
    {
        id: 104,
        name: "Darmstadt, Strahringerplatz",
        street: "Strahringerplatz 1",
        city: "Darmstadt",
        zip: "64289",
        latitude: 49.8728,
        longitude: 8.6512,
    },
    {
        id: 105,
        name: "Edingen-Neckarhausen",
        street: "Hauptstraße 356",
        city: "Edingen-Neckarhausen",
        zip: "68535",
        latitude: 49.4644,
        longitude: 8.6033,
    },
    {
        id: 106,
        name: "Egelsbach",
        street: "Am Berliner Platz",
        city: "Egelsbach",
        zip: "63329",
        latitude: 49.9675,
        longitude: 8.6639,
    },
    {
        id: 107,
        name: "Freigericht-Horbach",
        street: "Parkstraße 3",
        city: "Freigericht",
        zip: "63579",
        latitude: 50.138,
        longitude: 9.1647,
    },
    {
        id: 108,
        name: "Fulda, Bronnzeller Straße",
        street: "Bronnzeller Straße 4",
        city: "Fulda",
        zip: "36043",
        latitude: 50.5188,
        longitude: 9.6803,
    },
    {
        id: 109,
        name: "Fulda, Lindenstraße",
        street: "Lindenstraße 32",
        city: "Fulda",
        zip: "36037",
        latitude: 50.5507,
        longitude: 9.6833,
    },
    {
        id: 110,
        name: "Fulda, Magdeburger Straße",
        street: "Magdeburger Straße 24",
        city: "Fulda",
        zip: "36037",
        latitude: 50.5585,
        longitude: 9.6849,
    },
    {
        id: 111,
        name: "Fulda, Pacelliallee",
        street: "Pacelliallee 4",
        city: "Fulda",
        zip: "36043",
        latitude: 50.5481,
        longitude: 9.7066,
    },
    {
        id: 112,
        name: "Fulda, Petersberger Straße",
        street: "Petersberger Straße 76",
        city: "Fulda",
        zip: "36037",
        latitude: 50.5522,
        longitude: 9.6958,
    },
    {
        id: 113,
        name: "Gelnhausen",
        street: "Am Ziegelturm 2",
        city: "Gelnhausen",
        zip: "63571",
        latitude: 50.1996,
        longitude: 9.1912,
    },
    {
        id: 114,
        name: "Groß-Umstadt",
        street: "St.-Peray-Straße 13",
        city: "Groß-Umstadt",
        zip: "64823",
        latitude: 49.864,
        longitude: 8.9253,
    },
    {
        id: 115,
        name: "Großostheim-Ringheim",
        street: "Mittelweg 4a",
        city: "Großostheim",
        zip: "63762",
        latitude: 49.9343,
        longitude: 9.0388,
    },
    {
        id: 116,
        name: "Hanau",
        street: "Am Hauptbahnhof",
        city: "Hanau",
        zip: "63450",
        latitude: 50.1227,
        longitude: 8.9308,
    },
    {
        id: 117,
        name: "Hasselroth-Niedermittlau",
        street: "Taunusstraße 2",
        city: "Hasselroth",
        zip: "63594",
        latitude: 50.1707,
        longitude: 9.1195,
    },
    {
        id: 118,
        name: "Heusenstamm",
        street: "Hainhäuser Straße 5",
        city: "Heusenstamm",
        zip: "63150",
        latitude: 50.0454,
        longitude: 8.8559,
    },
    {
        id: 119,
        name: "Hünfeld-Michelsrombach",
        street: "Königskuppel 15",
        city: "Hünfeld",
        zip: "36088",
        latitude: 50.6596,
        longitude: 9.6738,
    },
    {
        id: 120,
        name: "Johannesberg",
        street: "Mühlbergstraße",
        city: "Johannesberg",
        zip: "63867",
        latitude: 50.0326,
        longitude: 9.1368,
    },
    {
        id: 121,
        name: "Lobbach",
        street: "Langenzeller Straße 1",
        city: "Lobbach",
        zip: "74931",
        latitude: 49.3562,
        longitude: 8.8675,
    },
    {
        id: 122,
        name: "Malsch",
        street: "Hauptstraße 122",
        city: "Malsch",
        zip: "69254",
        latitude: 49.2451,
        longitude: 8.673,
    },
    {
        id: 123,
        name: "Marburg, Universitätsklinikum",
        street: "Baldingerstraße 1",
        city: "Marburg",
        zip: "35043",
        latitude: 50.8166,
        longitude: 8.8075,
    },
    {
        id: 124,
        name: "Mömlingen",
        street: "Großostheimer Straße 1",
        city: "Mömlingen",
        zip: "63853",
        latitude: 49.8628,
        longitude: 9.0789,
    },
    {
        id: 125,
        name: "Mühlheim am Main",
        street: "Ulmenstraße 13h",
        city: "Mühlheim am Main",
        zip: "63165",
        latitude: 50.1083,
        longitude: 8.8329,
    },
    {
        id: 126,
        name: "Pfungstadt-Eschollbrücken",
        street: "Crumstädter Straße 12-14",
        city: "Pfungstadt",
        zip: "64319",
        latitude: 49.8116,
        longitude: 8.562,
    },
    {
        id: 127,
        name: "Rasdorf",
        street: "Landstraße 9",
        city: "Rasdorf",
        zip: "36169",
        latitude: 50.7165,
        longitude: 9.899,
    },
    {
        id: 128,
        name: "Reichartshausen",
        street: "Wannestraße 11",
        city: "Reichartshausen",
        zip: "74934",
        latitude: 49.3543,
        longitude: 8.9425,
    },
    {
        id: 129,
        name: "Rodenbach-Oberrodenbach",
        street: "Hanauer Straße 46",
        city: "Rodenbach",
        zip: "63517",
        latitude: 50.1393,
        longitude: 9.0551,
    },
    {
        id: 130,
        name: "Roßdorf-Gundernhausen",
        street: "Hauptstraße 24",
        city: "Roßdorf",
        zip: "64380",
        latitude: 49.8717,
        longitude: 8.7878,
    },
    {
        id: 131,
        name: "Sailauf",
        street: "Zum Bischling 4",
        city: "Sailauf",
        zip: "63877",
        latitude: 50.0228,
        longitude: 9.2562,
    },
    {
        id: 132,
        name: "Schöneck",
        street: "Nidderauer Straße 47",
        city: "Schöneck",
        zip: "61137",
        latitude: 50.1986,
        longitude: 8.8295,
    },
    {
        id: 133,
        name: "Steinau-Ulmbach",
        street: "Heinz-Désor-Straße 3a",
        city: "Steinau an der Straße",
        zip: "36396",
        latitude: 50.3704,
        longitude: 9.4219,
    },
    {
        id: 134,
        name: "Trebur-Astheim",
        street: "Berliner Straße 14",
        city: "Trebur",
        zip: "65468",
        latitude: 49.9357,
        longitude: 8.3754,
    },
    {
        id: 135,
        name: "Zuzenhausen",
        street: "Meckesheimer Straße 7/2",
        city: "Zuzenhausen",
        zip: "74939",
        latitude: 49.298,
        longitude: 8.8214,
    },
];
